import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '产品',
    links: [
      { label: 'Android下载', path: '/' },
      { label: 'iOS下载', path: '/' },
      { label: 'PC下载', path: '/' },
      { label: '版本更新', path: '/articles' },
    ],
  },
  content: {
    title: '内容',
    links: [
      { label: '游戏攻略', path: '/categories' },
      { label: '新闻资讯', path: '/articles' },
      { label: '官方公告', path: '/categories' },
      { label: '视频专区', path: '/categories' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '常见问题', path: '/' },
      { label: '联系客服', path: '/about' },
      { label: '关于我们', path: '/about' },
      { label: '用户协议', path: '/' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-5">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-sword-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                征途国际
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              经典热血国战MMORPG手游
              <br />
              全球5000万玩家的共同选择
              <br />
              官方正版 · 安全下载 · 畅快体验
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-5">
                {section.title}
              </h4>
              <ul className="space-y-3">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2021-2026 征途国际 版权所有 | 沪ICP备XXXXXXXX号 | 沪网文〔2026〕XXXX-XXX号
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-background-700 transition-all duration-200"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-base"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-background-700 transition-all duration-200"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-base"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-400 hover:text-background-100 hover:bg-background-700 transition-all duration-200"
              aria-label="QQ"
              rel="nofollow"
            >
              <i className="ri-qq-line text-base"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}